module.exports = __webpack_public_path__ + "img/img-chip-board.03eac14c.svg";